module.exports = __webpack_public_path__ + "img/minus-circle.97d9339e.svg";